export const GET_AGENT = 'GET_AGENT';
export const SET_AGENT = 'SET_AGENT';
export const CREATE_AGENT = 'CREATE_AGENT';
export const AGENT_SUBMITTED_POLICY = 'AGENT_SUBMITTED_POLICY';